import CrashDetectionMonitorTable from './CrashDetectionMonitorTable'
import { Container, Title } from './styles'

const CrashDetectionMonitorPage = () => {
  return (
    <Container>
      <Title>Monitor ตรวจจับการชน</Title>
      <CrashDetectionMonitorTable />
    </Container>
  )
}

export default CrashDetectionMonitorPage
